/**
 * CouponTicket — small purple ticket chip showing the applied coupon code.
 * Matches mockup: #f3effe bg / #6d4ddb text, ticket icon, 10.5px bold, radius 6px.
 */

import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

type Props = {
  code: string;
};

export function CouponTicket({ code }: Props) {
  const t = useTranslations();
  return (
    <span
      className="inline-flex items-center gap-1 rounded-md px-[7px] py-0.5 text-[10.5px] font-bold leading-none"
      style={{ background: "#f3effe", color: "#6d4ddb" }}
      title={t(keys.orders.rowCoupon, { code })}
    >
      {/* Ticket icon */}
      <svg
        aria-hidden="true"
        className="h-[11px] w-[11px] shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 7v3a2 2 0 0 0 0 4v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2Z" />
      </svg>
      {code}
    </span>
  );
}
